// EVA-266 (Tier 1 unification): canonical DD/MM/YYYY <-> ISO (YYYY-MM-DD) date
// helpers. These were copy-pasted into TenantsTable / OperatingExpensesTab /
// CapitalExpenditureTab (and had drifted). Pure functions — no Handsontable / DOM —
// so they can be unit-tested under bare Node (see spec/javascript/date_format_spec.rb).

// Display DD/MM/YYYY -> ISO YYYY-MM-DD. Returns '' when not parseable.
export function ddmmyyyyToISO(display) {
  if (typeof display !== 'string') return ''
  const trimmed = display.trim()
  // Already ISO (defensive — a grid may store either format).
  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return trimmed
  const m = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
  if (!m) return ''
  return `${m[3]}-${m[2].padStart(2, '0')}-${m[1].padStart(2, '0')}`
}

// ISO YYYY-MM-DD -> display DD/MM/YYYY, strict: returns `fallback` for anything
// that is not a well-formed ISO string. Used at the editor boundary (fallback ''
// clears the cell on invalid input) and by read-only grids/modals (fallback '—').
export function isoToDDMMYYYY(iso, fallback = '') {
  if (typeof iso !== 'string') return fallback
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (!m) return fallback
  return `${m[3]}/${m[2]}/${m[1]}`
}

// ISO YYYY-MM-DD -> display DD/MM/YYYY, showing an em dash for a missing/invalid
// date. Used by read-only grids and modals (IndexationProfilesTable, RentReviewsModal).
export function isoToDisplayDateOrDash(iso) {
  return isoToDDMMYYYY(iso, '—')
}

// ISO YYYY-MM-DD -> display DD/MM/YYYY, lenient: passes a non-ISO value through
// unchanged (null/undefined become ''). Used by renderers, which should show
// whatever is stored rather than blanking an unexpected value.
export function isoToDisplayDate(value) {
  const m = typeof value === 'string' && value.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  return m ? `${m[3]}/${m[2]}/${m[1]}` : (value ?? '')
}
